import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bootstrap-price-for-precision',
  templateUrl: './bootstrap-price-for-precision.component.html',
  styleUrls: ['./bootstrap-price-for-precision.component.scss']
})
export class BootstrapPriceForPrecisionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
